import { render, staticRenderFns } from "./HealthcareService.vue?vue&type=template&id=785f6bd8&"
import script from "./HealthcareService.vue?vue&type=script&lang=js&"
export * from "./HealthcareService.vue?vue&type=script&lang=js&"
import style0 from "./HealthcareService.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports